import {updateSocketSubscribes} from "../Sockets/UpdateSocketSubscribes";
import {socket} from "../../../context/socket";

export function updateHistoryOrdersOnSocket(type, message){
    return (dispatch, getState) => {
        let tickerState = getState().ticker;

        if (Number(message.room.split(`${type}_`)[1]) === Number(tickerState.current_id)) {
            dispatch({
                type: 'ADD_NEW_ORDER_SHOW',
                payload: message.data
            });
        } else {
            // console.log('updateHistoryOrdersOnSocket')
            dispatch(updateSocketSubscribes(socket));
        }
    }
}